module.exports = "pegasus/assets/styleGroup1-facebook.gif";